<template>
  <div class="locale-toggle" role="group" :aria-label="$t('locale.switchToEn')">
    <button
      type="button"
      class="locale-btn"
      :class="{ active: locale === 'pt-BR' }"
      :aria-label="$t('locale.switchToPt')"
      :aria-pressed="locale === 'pt-BR'"
      @click="setLocale('pt-BR')"
    >
      <img
        class="flag-icon"
        src="/images/flags/pt-br.svg"
        width="24"
        height="16"
        alt=""
      >
    </button>
    <button
      type="button"
      class="locale-btn"
      :class="{ active: locale === 'en' }"
      :aria-label="$t('locale.switchToEn')"
      :aria-pressed="locale === 'en'"
      @click="setLocale('en')"
    >
      <img
        class="flag-icon"
        src="/images/flags/en.svg"
        width="24"
        height="16"
        alt=""
      >
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { persistLocale } from '@/utils/locale';
import { setDocumentLocale } from '@/i18n';
import type { LocaleCode } from '@/data/types';

const { locale } = useI18n();

function setLocale(code: LocaleCode) {
  locale.value = code;
  persistLocale(code);
  setDocumentLocale(code);
}
</script>

<style scoped lang="scss">
.locale-toggle {
  display: flex;
  gap: 6px;
}

.locale-btn {
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 50%;
  border: 2px solid transparent;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.3s ease, transform 0.2s ease;

  &:focus-visible {
    outline: 2px solid #ffae00;
    outline-offset: 2px;
  }

  &.active {
    border-color: #b4d455;
    transform: scale(1.05);
  }

  .flag-icon {
    display: block;
    width: 24px;
    height: 16px;
    object-fit: cover;
    border-radius: 2px;
    pointer-events: none;
  }
}
</style>
